import { render, staticRenderFns } from "./CmgRewardsCountryMismatchModal.vue?vue&type=template&id=f4a001fa&scoped=true&lang=pug"
import script from "./cmg-rewards-country-mismatch-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-country-mismatch-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsCountryMismatchModal.vue?vue&type=style&index=0&id=f4a001fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a001fa",
  null
  
)

export default component.exports